import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { setEnvironment } from '../config/environment';

function useEnvironment() {
  const theme = useTheme();
  const isDark = theme?.palette?.mode === 'dark';
  const { environment, allowChangingEnvironment } = useSelector((state) => state.environment);

  useEffect(() => {
    setEnvironment(environment);
  }, [environment]);

  const environmentBackgroundColor = allowChangingEnvironment
    ? environment === 'production'
      ? isDark
        ? 'rgba(216, 54, 79, 0.18)'
        : '#ffdfdf'
      : isDark
        ? 'rgba(245, 213, 65, 0.12)'
        : '#f6ffc1'
    : '';

  return { environment, allowChangingEnvironment, environmentBackgroundColor };
}

export default useEnvironment;
